import { render } from "./Typing.vue?vue&type=template&id=35004c11&scoped=true"
import script from "./Typing.vue?vue&type=script&lang=js"
export * from "./Typing.vue?vue&type=script&lang=js"

import "./Typing.vue?vue&type=style&index=0&id=35004c11&scoped=true&lang=css"

import exportComponent from "/Users/cole/Desktop/중요/xz_opr/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35004c11"]])

export default __exports__